import rest from "@/restUtils";
import utils from '@/utils';

const path = '/astromap';

export default {
    namespace: true,
    state: {
        astroMaps: []
    },

    actions: {
        async listAstroMaps({commit}) {
            try {
                let astroMaps = await rest.doGet(path);
                commit('setAstroMaps', astroMaps);
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async getAstroMap(context, id) {
            try {
                let astroMap = await rest.doGet(`${path}?id=${id}`);

                let birthday = utils.convertDateToUTC(new Date(astroMap.birthday));
                let transitDate = utils.convertDateToUTC(new Date(astroMap.transitDate));
                Object.assign(astroMap, {birthday, transitDate});

                return astroMap;
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async createAstroMap(context, payload) {
            try {
                let astroMap = await rest.doPost(path, payload);
                return astroMap;
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async updateAstroMap(context, [id, payload]) {
            try {
                let astroMap = await rest.doPost(`${path}?id=${id}`, payload);
                return astroMap;
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async changeAstroMapName(context, [id, name]) {
            try {
                let astroMap = await rest.doPost(`${path}/change-name?id=${id}`, {name});
                return astroMap;
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async deleteAstroMap(context, id) {
            let success;
            try {
                await rest.doDelete(`${path}?id=${id}`);
                success = true;
            } catch (error) {
                success = false;
                alert(error.response.data.message);
            }
            return success;
        },
    },

    mutations: {
        setAstroMaps(state, payload) {
            state.astroMaps = payload;
        }
    },

    getters: {
        astroMaps: state => state.astroMaps,
    }
}